import { render, staticRenderFns } from "./BorderWidthColor.vue?vue&type=template&id=27e8c5c2&scoped=true&"
import script from "./BorderWidthColor.vue?vue&type=script&lang=js&"
export * from "./BorderWidthColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8c5c2",
  null
  
)

export default component.exports